import { CourseCardSkeleton } from './CourseCardSkeleton';

interface CourseCardSkeletonGridProps {
  count?: number;
}

export function CourseCardSkeletonGrid({ count = 9 }: CourseCardSkeletonGridProps) {
  return (
    <div className="bg-surface-1 w-full">
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-4 lg:gap-6">
          {Array.from({ length: count }).map((_, i) => (
            <CourseCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}

